import { actionTypes as externalAccountActions } from './externalAccount.actions';

const initialState = {
    isExternalAccountError: null,
    externalAccountUrl: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case externalAccountActions.SET_EXTERNAL_ACCOUNT_URL:
            return {
                ...state,
                externalAccountUrl: action.externalAccountUrl,
                isExternalAccountError: false,
            };
        case externalAccountActions.SET_EXTERNAL_ACCOUNT_ERROR:
            return {
                ...state,
                isExternalAccountError: true,
            };
        case externalAccountActions.CLEAR_EXTERNAL_ACCOUNT_DATA:
            return {
                ...state,
                isExternalAccountError: null,
                externalAccountUrl: null,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /src/js/common/externalAccount/externalAccount.reducer.js